import { Stack } from '@mantine/core';
import { LeadFunnel } from '../../../Leads/views/components';
import type { PartnerLeadExtended } from '../PartnerViewController';

interface PartnerLeadFunnelsProps {
  /** Только активные лиды партнёра (без архивных и без финальных статусов). */
  activeLeads: PartnerLeadExtended[];
  /** Колбек после успешной смены статуса — обычно `reload` от usePartnerViewController. */
  onRefresh: () => void | Promise<void>;
}

/**
 * Воронки активных лидов партнёра.
 *
 * При заходе в карточку партнёра показывает один funnel на каждый активный лид
 * — чтобы сразу было видно текущие процессы и их прогресс.
 *
 * Каждый `LeadFunnel` сам подгружает свою историю смен статуса и сам управляет
 * сменой статуса — этот компонент только мапит активные лиды.
 */
export function PartnerLeadFunnels({ activeLeads, onRefresh }: PartnerLeadFunnelsProps) {
  if (activeLeads.length === 0) {
    return null;
  }

  return (
    <Stack gap='xs'>
      {activeLeads.map(lead => (
        <LeadFunnel key={lead.id} lead={lead} onChanged={onRefresh} />
      ))}
    </Stack>
  );
}
